import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import { GreenNotify } from "../../helper/helper";
import Loader from "../../components/loader/loader";
import { message, Select } from "antd";

const { Option } = Select;


const UploadEng = () => {
  const [excelData, setExcelData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileSelected, setFileSelected] = useState(false);
  const navigate = useNavigate();

  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";

  const [employers, setEmployers] = useState([]);
  const [selectedEmployer, setSelectedEmployer] = useState(null);

  useEffect(() => {
    const getAllEmployers = () => {
      let getRes = (res) => {
        console.log("res of getAllEmployers", res);
        setEmployers(res?.data?.data || []);
      };

      callApi(
        "GET",
        routes.getAllEmployers,
        null,
        setIsLoading,
        getRes,
        (error) => {
          console.log("error", error);
        }
      );
    };

    getAllEmployers();
  }, []);

  const handleEmployerChange = (value) => {
    setSelectedEmployer(value);
  };

  const containsEnglish = (str) => {
    const englishPattern = /[A-Za-z]/;
    return englishPattern.test(str);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileSelected(true);
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        let workbook;
        if (file.type === "text/csv") {
          workbook = XLSX.read(data, { type: "string" });
        } else {
          workbook = XLSX.read(data, { type: "binary" });
        }

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        console.log("sheet", sheet);

        // Convert Excel sheet to JSON
        let jsonData = XLSX.utils.sheet_to_json(sheet);

        // Helper function to convert Excel date serial number to JavaScript Date
        const excelDateToJSDate = (excelSerial) => {
          const date = new Date((excelSerial - 25569) * 86400 * 1000);
          return date.toISOString(); // Convert to ISO string
        };

        // Convert 'expiry date' if it exists and is a number
        jsonData = jsonData.map((row) => {
          if (row["expiry date"] && !isNaN(row["expiry date"])) {
            row["expiry date"] = excelDateToJSDate(row["expiry date"]);
          }
          return row;
        });

        console.log("json ", jsonData);

        // Check if the JSON contains any English text
        const containsEnglishText = jsonData.some((row) =>
          Object.values(row).some((cell) => containsEnglish(cell))
        );

        if (containsEnglishText) {
          setExcelData(jsonData);
        } else {
          message.error("The file does not contain English text.");
        }
      };

      // Handle reading file based on type (CSV or binary Excel)
      if (file.type === "text/csv") {
        reader.readAsText(file);
      } else {
        reader.readAsBinaryString(file);
      }
    } else {
      setFileSelected(false);
    }
  };

  const createOffer = () => {
    const body = excelData;
    let getRes = (res) => {
      console.log("res of createOfferEng", res);
      GreenNotify("Offer is uploaded successfully");
      navigate("/offerEng");
    };

    callApi(
      "POST",
      routes.uploadEngFile + selectedEmployer,
      body,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };


  return (
    <div className="modern-page-container">
      <Loader loading={isLoading} />
      
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div>
            <h1 className="page-title">Upload Offers (English)</h1>
            <p className="page-subtitle">Upload Excel file with English offers</p>
          </div>
          <button
            onClick={() => navigate("/offerEng")}
            className="modern-back-btn"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back to Offers
          </button>
        </div>
      </div>

      {/* Upload Form Card */}
      <div className="form-card">
        <div className="form-header">
          <h2 className="form-title" style={{ margin: 0 }}>
            Upload Configuration
          </h2>
          <p className="form-description">Select employer and upload your Excel/CSV file</p>
        </div>

        <div className="form-content">
          <div className="upload-steps">
            <div className={`upload-step ${selectedEmployer ? 'completed' : 'active'}`}>
              <div className="step-number">1</div>
              <div className="step-content">
                <h3 className="step-title">Select Employer</h3>
                <p className="step-description">Choose the employer for these offers</p>
                <Select
                  placeholder="Select an employer"
                  onChange={handleEmployerChange}
                  className="modern-select employer-select"
                  size="large"
                  style={{ width: "100%", maxWidth: "400px" }}
                  value={selectedEmployer}
                >
                  {employers.map((employer) => (
                    <Option key={employer._id} value={employer._id} label={employer.name}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <img
                          src={employer.image || dummyImage}
                          alt={employer.name}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "8px",
                            objectFit: "cover",
                            border: "2px solid #e2e8f0"
                          }}
                          onError={(e) => {
                            e.target.src = dummyImage;
                          }}
                        />
                        <span>{employer.name}</span>
                      </div>
                    </Option>
                  ))}
                </Select>
              </div>
            </div>

            <div className={`upload-step ${fileSelected ? 'completed' : 'active'}`}>
              <div className="step-number">2</div>
              <div className="step-content">
                <h3 className="step-title">Upload File</h3>
                <p className="step-description">Select your Excel or CSV file</p>
                <div className="file-upload-area">
                  <input
                    type="file"
                    accept=".xlsx, .xls, .csv"
                    onChange={handleFileChange}
                    id="file-input"
                    className="file-input-hidden"
                  />
                  <label htmlFor="file-input" className="file-upload-label">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M17 8L12 3L7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 3V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="upload-text">
                      {fileSelected ? "File selected! Click to change" : "Click to browse or drag and drop"}
                    </span>
                    <span className="upload-hint">Supported: .xlsx, .xls, .csv</span>
                  </label>
                </div>
              </div>
            </div>

            <div className={`upload-step ${fileSelected ? 'active' : ''}`}>
              <div className="step-number">3</div>
              <div className="step-content">
                <h3 className="step-title">Upload</h3>
                <p className="step-description">Review and upload your offers</p>
                <button
                  onClick={createOffer}
                  className="submit-btn"
                  disabled={!fileSelected || !selectedEmployer}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M17 8L12 3L7 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 3V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Upload Offers
                </button>
              </div>
            </div>
          </div>
        </div>

        {excelData && (
          <div className="data-preview">
            <h3 className="preview-title">Data Preview</h3>
            <div className="preview-info">
              <span className="preview-badge">{excelData.length} offers found</span>
            </div>
            <div className="preview-content">
              <pre>{JSON.stringify(excelData, null, 2)}</pre>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadEng;
